var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        "append-to-body": true,
        "close-on-click-modal": false,
        "show-close": true,
        title: _vm.$t("trailer.exportNotice"),
        visible: _vm.dialogSelectExport,
        width: "500px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogSelectExport = $event
        },
        close: _vm.clearForm,
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "selectForm",
          staticClass: "demo-selectForm",
          attrs: { model: _vm.selectForm, "label-position": "top" },
        },
        [
          _c(
            "el-form-item",
            {
              staticStyle: { width: "100%" },
              attrs: {
                label: _vm.$t("trailer.selectExportContentIncludesImages"),
                rules: {
                  required: true,
                  message: _vm.$t("placeOrder.pleaseInput"),
                  trigger: ["blur"],
                },
                prop: "withImage",
              },
            },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.selectForm.withImage,
                    callback: function ($$v) {
                      _vm.$set(_vm.selectForm, "withImage", $$v)
                    },
                    expression: "selectForm.withImage",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: true } }, [
                    _vm._v(_vm._s(_vm.$t("trailer.withImages"))),
                  ]),
                  _c("el-radio", { attrs: { label: false } }, [
                    _vm._v(_vm._s(_vm.$t("trailer.withoutImages"))),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticStyle: { "text-align": "right", margin: "15px 0" } },
        [
          _c(
            "el-button",
            {
              attrs: { size: "small" },
              on: {
                click: function ($event) {
                  _vm.dialogSelectExport = false
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("GlobalSetObj.Cancelar")) + " ")]
          ),
          _c(
            "el-button",
            {
              attrs: { size: "small", type: "primary" },
              on: { click: _vm.comfire },
            },
            [_vm._v(_vm._s(_vm.$t("collectionCenter.CheckItOutNow")) + " ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }